//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ReportCheckListWorkPackage from './ReportCheckListWorkPackage.vue'
import ReportCheckListWorkType from './ReportCheckListWorkType.vue'

export default {
  components: {
    ReportCheckListWorkPackage,
    ReportCheckListWorkType
  },
  props: {
    report: {
      default: null,
      type: Object
    },
    workPackages: {
      type: Array,
      default () {
        return []
      }
    },
    workTypes: {
      type: Array,
      default () {
        return []
      }
    },
    allWorkPackages: {
      type: Array,
      default () {
        return []
      }
    },
    allWorkTypes: {
      type: Array,
      default () {
        return []
      }
    },
    roleExecutor: {
      type: Boolean,
      default: false
    },
    setup: {
      type: Boolean,
      default: false
    },
    state: {
      type: String,
      default: ''
    },
    reportActionsAccess: {
      type: Object,
      default () {
        return {}
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    dispatcherInterface: {
      type: Boolean,
      default: false
    },
    showPreviousDepartures: {
      type: Boolean,
      default: false
    },
    serviceObject: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  methods: {
    onWorkUpdated: function (workType) {
      const allWorkTypes = []
      for (let i = 0; i < this.allWorkPackages.length; i++) {
        const workPackageWorkTypes = this.allWorkPackages[i].workTypes
        allWorkTypes.push(...workPackageWorkTypes)
      }
      allWorkTypes.push(...this.allWorkTypes)

      allWorkTypes.forEach(wT => {
        if (wT.id === workType.id && wT.uniqueKey !== workType.uniqueKey) {
          const SYNC_FIELDS = ['done', 'donePartially', 'comment', 'technologicalOperations']
          SYNC_FIELDS.forEach(field => {
            wT[field] = workType[field]
          })
        }
        return wT.id === workType.id
      })
    },
    onRemarkChanged: function () {
      this.$emit('remark-changed')
    }
  }
}

